const getSectionNodes = state => state.guidebook.working.sectionNodes;

export default getSectionNodes;
